import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import ConsoleTab from "./ConsoleTab";
import NetworkTab from "./NetworkTab";
import InfoTab from "./InfoTab";
import ActionsTab from "./ActionsTab";

interface LogsTabProps {
  consoleLogs?: any[];
  networkLogs?: any[];
  systemInfo?: {
    url?: string;
    timestamp?: string | Date;
    os?: string;
    browser?: string;
    windowSize?: string;
    country?: string;
    screenshotDimensions?: string;
    timezone?: string;
  };
  actionLogs: any[];
}

const LogsTab: React.FC<LogsTabProps> = ({
  consoleLogs,
  networkLogs,
  systemInfo,
  actionLogs,
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_: React.SyntheticEvent, newIndex: number) => {
    setTabIndex(newIndex);
  };

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        id="snr-ai-JsonTableView-tabs"
      >
        <Tab label="Info" id="snr-ai-JsonTableView-infoTab" />
        <Tab label="Console" id="snr-ai-JsonTableView-jsonTab" />
        <Tab label="Network" id="snr-ai-JsonTableView-tableTab" />
        <Tab label="Action" id="snr-ai-JsonTableView-actionTab" />
      </Tabs>
      {tabIndex === 0 && (
        <InfoTab
          url={systemInfo?.url}
          timestamp={systemInfo?.timestamp}
          os={systemInfo?.os}
          browser={systemInfo?.browser}
          windowSize={systemInfo?.windowSize}
          country={systemInfo?.country}
          screenshotDimensions={systemInfo?.screenshotDimensions}
          timezone={systemInfo?.timezone}
        />
      )}                                                                                                 
      {tabIndex === 1 && (
        <ConsoleTab devToolsData={consoleLogs} selectedTab={"console"} />
      )}
      {tabIndex === 2 && (
        <NetworkTab networkRequests={networkLogs} selectedTab={"network"} />
      )}
      {tabIndex === 3 && (
        <ActionsTab actionLogs={actionLogs} />
      )}
    </>
  );
};

export default LogsTab;
